import { FormikProps } from 'formik';

/* eslint-disable @typescript-eslint/no-explicit-any */
export interface IGroupsAndSubgroups {
  [key: string]: string;
}

type IParameterType =  'DealIndexParams' | 'ContactIndexParams' | 'CheckQueue' | '';

export interface IWorkflowStepDetails {
  id: string;
  name: string;
  numericId: number;
  workflowId: string;
  type: string;
  entityType: string;
  workflowName?: string;
}

export interface IWorkflowDetails {
  entityType: string;
  id: string;
  name: string;
  numericId: number;
  type?: string;
  stepType?: string;
  workflowId?: string;
  workflowSteps?: IWorkflowStepDetails[];
  workflowName?:string;
}

export interface IQueueConfiguration {
  [key: string]: unknown;

  id?: string;
  group: string | null;
  subgroup: string | null;
  paramsType: IParameterType | null;
  // menuWorkflowDetails: {
  //   workflowIds: string[];
  //   stepIds: string[];
  // };
  menuWorkflows: IWorkflowDetails[];
  isQueueEnabled: boolean | null;
  isCountRequired: boolean;
  isDownPaymentDeclineQueue: boolean | null;
  isBuyBackQueue: boolean | null;
  hasMyContacts: boolean | null;
  hasMyTeamContacts: boolean | null;
  hasMyDeals: boolean | null;
  hasMyTeamDeals: boolean | null;
  hasRedDeals: boolean | null;
  hasAmberDeals: boolean | null;
  hasGreenDeals: boolean | null;
  hasRedContacts: boolean | null;
  hasAmberContacts: boolean | null;
  hasGreenContacts: boolean | null;
  isUnAssigned: boolean | null;
  isHotTitles: boolean | null;
  isAcceleratedTitleSupported: boolean | null;
  acceleratedTitleTitleIsReleasable: boolean | null;
  isSpanish: boolean | null;
  unAssignedTag: 'Accounting' | 'Bank' | 'LP' | 'LC' | 'Titles' | null;
  checkRequestStatus:
    | 'AddComment'
    | 'Submitted'
    | 'Approved'
    | 'Declined'
    | 'CheckCut'
    | 'CheckVoid'
    | 'CheckProcessed'
    | 'DownloadPdf'
    | 'Sent'
    | null;
  description: string | null;
  roleId: string | null;
  queueEmailRoles: (
    | 'LC'
    | 'LP'
    | 'Titles'
    | 'Accounting'
    | 'TeamDirector'
    | 'TeamManager'
    | 'TitlesManager'
    | 'TitlesLead'
    | 'Bank'
    | 'LCA'
    | 'SDR'
  )[];
  excludedLenderIds: string[];
  includedLenderIds: string[];
  includedPrimaryLeadSourceIds: string[],
  lenderIds: string[];
  isQueueEmailRequired: boolean | null;
  hasReferralContactId: 'False' | 'True' | 'None' | null;
  hasDeals: 'False' | 'True' | 'None' | null;
  hasActiveDeal: 'False' | 'True' | 'None' | null;
  isDealActive: 'False' | 'True' | 'None' | null;
  assetSelected: 'False' | 'True' | 'None' | null;
  checkCombineWorkflowStep: boolean | null;
}

export interface IAddSubGroup {
  name: string;
  paramsType: IParameterType;
}

export interface Config {
  name: string;
  title: string;
  value: any;
  type: string;
  options?: any[];
  component?: any;
}

export interface IMenuSubgroupWorkFlow {
  id: string;
  name: string;
  type: string;
  numericId: number;
  entityType: string;
  stepType?: string;
}

export interface IRole {
  id: string;
  name: string;
  commentsColor: string;
  commentsColorPriority: number;
  permission: string;
  users: number;
  numericId: number;
}

export interface IQueue {
  id: string;
  group: string;
  subgroup: string;
}

export enum IWorflowStepType {
  Workflow = 'W',
  Step = 'S',
}

export interface IMenuWorkflowProps extends Partial<FormikProps<IQueueConfiguration>> {
  queueSubGroup: string;
  menuWorkflows: IWorkflowDetails[];
}

export interface ILeadSourceConfiguration {
  id: string;
  numericId: number;
  name: string;
  description: string;
  isSecondary: boolean;
  allowSecondary: boolean;
  isAutoResponseEnabled: boolean;
  autoResponsePostUrl: string;
  autoResponseVersion: number;
  enableCamRef: boolean;
  isAutoDeadEnabled: boolean;
  isAutoDelayedResponseEnabled: boolean;
  autoDeadDelayedResponse: number;
  autoDelayedResponseOfferCallbackBaseUrl: string;
  createdBy: {
    id: string;
    email: string;
    name: string;
  };
  createdDate: string;
  apiKey: string;
  isDropdownEnabled: boolean;
  thankYouPageBaseUrl: string;
  customerPortalUrl: string;
  cdxPageFlows: {
    orderNumber: number;
    pageName: string;
  }[];
}